import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import LoadingCircle from './loading/LoadingCircle';
import { selectLoadingComplete, useAppSelector } from '@aorg/store';

function LoadingDialog() {
  const isOpen = useAppSelector(selectLoadingComplete);

  return (
    <Transition appear show={!isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={() => null}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-white/20 bg-opacity-75" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="px-14 py-10 transform overflow-hidden rounded-lg bg-black/80 text-left align-middle shadow-xl transition-all">
                <LoadingCircle />
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}

export default LoadingDialog;
